import { render, staticRenderFns } from "./PasswordModify.vue?vue&type=template&id=b7baf646&scoped=true"
import script from "./PasswordModify.vue?vue&type=script&lang=js"
export * from "./PasswordModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7baf646",
  null
  
)

export default component.exports